/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useContext, useEffect, useState } from "react";

import { useAccount, useConnect, useDisconnect, useSignMessage } from "wagmi";
import { useMediaQuery } from "react-responsive";

import {
  createSiweMessage,
  verifySignature,
  envChains,
  getChainId,
  handleDeepLink,
} from "utils/helper";
import { useRootContext } from "context/app-context";
import RejectedTransactionModal from "components/modals/ErrorModalTransactions";

export const WalletConnectContext = createContext(null);

const WalletConnectProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [rejectedErrorMsg, setRejectedErrorMsg] = useState("");

  const { disconnect } = useDisconnect();
  const { signMessageAsync } = useSignMessage();
  const { address, connector } = useAccount();
  const {
    isSignWallet,
    selectedNetwork,
    handleSignWallet,
    handleToggleWalletSidebar,
  } = useRootContext();


  const { connect, connectors, error, pendingConnector } = useConnect({
    chainId: getChainId(selectedNetwork),
  });
  const isMobile = useMediaQuery({ query: "(max-width: 1180px)" });

  const handleConnectWallet = (connector) => {
    if (!connector?.ready) {
      handleDeepLink()
    } else {
      if (connector?.name === "WalletConnect" && isMobile) {
        handleToggleWalletSidebar();
      }
      setLoading(true);
      connect({ connector });
    }
  };

  const handleDisconnectWallet = () => {
    disconnect();
    handleSignWallet(false);
    // localStorage.removeItem("wagmai_signature");
    // localStorage.removeItem("wagmi.walletSignature");
    // localStorage.removeItem("txHashType");
    localStorage.clear()
  };

  const handlingErrorAndSign = async () => {
    if (address && !error) {
      const currentChainId = await connector?.getChainId();
      const msg = createSiweMessage(
        address,
        "Sign in to Vanar Swap.",
        currentChainId
      );
      signMessageAsync({ message: msg })
        .then(async (res) => {
          const verify = await verifySignature(msg, res);
          if (verify) {
            handleSignWallet(true);
            localStorage.setItem("wagmai_signature", res);
            setLoading(false);
            handleToggleWalletSidebar();
          } else {
            handleDisconnectWallet();
          }
        })
        .catch((error) => {
          const err = JSON.parse(JSON.stringify(error));
          if (Object.keys(err).length > 0) {
            handleDisconnectWallet();
            setRejectedErrorMsg("User denied message signature.");
          }
          setLoading(false);
        });
    } else if (error) {
      setLoading(false);
      setRejectedErrorMsg("User Denied Authorization");
    }
  };

  useEffect(() => {
    if (!isSignWallet) handlingErrorAndSign();
  }, [error, address]);
  return (
    <>
      <WalletConnectContext.Provider
        value={{
          loading,
          address,
          envChains,
          connector,
          pendingConnector,
          walletList: connectors,
          handleConnectWallet,
          handleDisconnectWallet,
        }}
      >
        {children}
        {rejectedErrorMsg && (
          <RejectedTransactionModal
            show={rejectedErrorMsg ?? false}
            onHide={() => setRejectedErrorMsg("")}
            errorMessage={rejectedErrorMsg}
          />
        )}
      </WalletConnectContext.Provider>
    </>
  );
};

export default WalletConnectProvider;

export const useWalletConnect = () => {
  const {
    loading,
    address,
    envChains,
    connector,
    walletList,
    pendingConnector,
    handleConnectWallet,
    handleDisconnectWallet,
  } = useContext(WalletConnectContext);

  return {
    loading,
    address,
    envChains,
    connector,
    walletList,
    pendingConnector,
    handleConnectWallet,
    handleDisconnectWallet,
  };
};
